<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:95%;margin-left: 2.5%;margin-top:1.5%;height:95%;background-color: white;">
			<div style="width: 100%;height: 95%;display: flex;flex-direction: row;align-items: center;">
                <div style="width: 45%;margin-right: 5%;border-radius: 5px;border:0.5px solid #efefef;height: 100%;">
                    
                    <div style="font-size: 20px;padding:5px;display: flex;flex-direction: row;align-items: center;">
                        <div>编辑</div>
                        <div style="width: 70px;height: 30px;color:white;background-color: #3c9cff;border-radius: 5px;display: flex;align-items: center;justify-content: center;font-size: 18px;margin-left: auto;"
                        @click="save()"
                        >保存</div>
                    </div>
                    <vue-editor ref="myEditor"  v-if="content!=null" v-model="content" :editor-toolbar="customToolbar" style="height: 100%;width:100%;"></vue-editor>
                </div>
                <div style="width: 45%;margin-left: 5%;border-radius: 5px;border:0.5px solid #efefef;height: 100%;">
                     <div style="font-size: 20px;padding:5px;border-bottom: 0.5px solid #efefef;">预览</div>
                    <div style="width:96%;height:96%;padding:2%" v-html="content"></div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import {post} from "../axios/request.js"
import { VueEditor } from "vue2-editor";
export default {
  name:"xjt",
  components: { VueEditor },
  data() {
    return {
        customToolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["image", "code-block"]
        ],
        content:null
    }
  },
  mounted() {
    post("/api/getintroduce",{}).then((res)=>{
        const content=res.data.data[0].content
        this.content=''
        console.log(this.content)
        this.$nextTick(() => {
        if (this.$refs.myEditor) {
            this.$refs.myEditor.quill.clipboard.dangerouslyPasteHTML(0,content)
            this.$forceUpdate();
            console.log(this.content)
        }
      });
        

    })
  },
  methods: {
    save(){
        post("/api/admin/updateintroduce",{content:this.content}).then((res)=>{
            if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    message: res.data.msg,
                    type: 'success'
                });
            }else{
                this.$notify({
                    title: '错误',
                    message: '未知的系统错误',
                    type: 'error'
                });
            }
        });
    }
  }
}
</script>
<style scoped>

</style>